export default {
      id: "svg-icon-star-silver-usage",
      viewBox: "0 0 43 42",
      url: __webpack_public_path__ + "static/images/svg-icons.svg#svg-icon-star-silver",
      toString: function () {
        return this.url;
      }
    }


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons-svg/star-silver.svg
// module id = L98g
// module chunks = 4